import React, { useMemo, useState } from "react";
import { Overline } from "./Overline";
import { BracketButton } from "./BracketButton";
import { commissionTiers } from "../data/content";
const MIN = 20000;
const MAX = 200000;
const fmt = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0
});
export function Commission() {
  const [revenue, setRevenue] = useState(80000);
  const rate = useMemo(() => {
    const tier = [...commissionTiers].reverse().find(t => revenue >= t.from);
    return tier ? tier.rate : commissionTiers[0].rate;
  }, [revenue]);
  const progress = (revenue - MIN) / (MAX - MIN) * 100;
  return <section id="remuneration" className="scroll-mt-20 py-24 md:py-36" data-id="element-42" data-mp="2lp14dx3s8qtu">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 md:px-10 lg:grid-cols-12 lg:gap-10" data-id="element-43" data-mp="2qm131myayrax">
        <div className="lg:col-span-5" data-id="element-44" data-mp="2uq8rrk4rg795">
          <Overline data-id="element-45" data-mp="2un3489bs5dfj">Rémunération</Overline>
          <h2 className="mt-6 text-[40px] font-semibold leading-[1] tracking-[-0.035em] md:text-[60px]" data-id="element-46" data-mp="2zp28dlfcgedj">
            Plus vous vendez, <span className="font-serif font-normal italic text-brand" data-id="element-47" data-mp="f8v9wsfijt3s">plus vous gagnez.</span>
          </h2>
          <p className="mt-8 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-48" data-mp="b4f7x290t5tu">
            Votre pourcentage de commission augmente avec votre chiffre d'affaires annuel. Faites glisser le curseur pour estimer votre
            rémunération.
          </p>
          <ul className="mt-10 max-w-md divide-y divide-paper-line border-y border-paper-line text-[15px]" data-id="element-49" data-mp="yvknrheyny45">
            {commissionTiers.map((t, i) => {
            const next = commissionTiers[i + 1];
            const active = rate === t.rate;
            return <li key={t.rate} className={`flex justify-between py-3 transition-colors duration-150 ${active ? "text-ink" : "text-ink-faint"}`} data-id="element-50" data-mp="k6oexi52yh2h" data-mpi={i}>
                  <span data-id="element-51" data-mp="1hndfl8iandaa">{next ? `${fmt.format(t.from)} – ${fmt.format(next.from)}` : `Au-delà de ${fmt.format(t.from)}`}</span>
                  <span className={`font-semibold ${active ? "text-brand-deep" : ""}`} data-id="element-52" data-mp="1ct96ojpgwv6k">{t.rate} %</span>
                </li>;
          })}
          </ul>
        </div>

        <div className="border border-paper-line bg-white p-6 md:p-12 lg:col-span-6 lg:col-start-7" data-id="element-53" data-mp="3b3q57w6ako6n">
          <label htmlFor="revenue" className="text-[14px] font-medium text-ink-muted" data-id="element-54" data-mp="2xcuv6gk2411h">
            Chiffre d'affaires annuel généré
          </label>
          <p className="mt-2 text-[40px] font-semibold tracking-[-0.03em] md:text-[48px]" data-id="element-55" data-mp="2nefcn1z3i03l">{fmt.format(revenue)}</p>
          <input id="revenue" type="range" min={MIN} max={MAX} step={5000} value={revenue} onChange={e => setRevenue(Number(e.target.value))} className="range-brand mt-6 w-full" style={{
          background: `linear-gradient(to right, #F26522 ${progress}%, #ECE8E2 ${progress}%)`
        }} data-id="element-56" data-mp="2sf30xfvxw2u4" />
          <div className="mt-2 flex justify-between text-[12px] text-ink-faint" data-id="element-57" data-mp="hkxidqdpphqp">
            <span data-id="element-58" data-mp="rpdvwd3pymrc">{fmt.format(MIN)}</span>
            <span data-id="element-59" data-mp="rqf6kggtp78j">{fmt.format(MAX)}</span>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-6 border-t border-paper-line pt-8" data-id="element-60" data-mp="mrcdlue4argx">
            <div data-id="element-61" data-mp="10hz3qy5tb91e">
              <p className="text-[14px] text-ink-muted" data-id="element-62" data-mp="10ih4a6zic9f4">Votre taux</p>
              <p className="mt-1 text-[64px] font-semibold leading-none tracking-[-0.05em] text-brand md:text-[88px]" data-id="element-63" data-mp="vripjbu63jdz">{rate}%</p>
            </div>
            <div data-id="element-64" data-mp="1af3oqunx8ygm">
              <p className="text-[14px] text-ink-muted" data-id="element-65" data-mp="1aek8rjhu0k58">Vous percevez</p>
              <p className="mt-1 text-[32px] font-semibold leading-tight tracking-[-0.03em] md:text-[40px]" aria-live="polite" data-id="element-66" data-mp="15g90hd76qhp4">
                {fmt.format(revenue * rate / 100)}
              </p>
              <p className="mt-1 text-[13px] text-ink-faint" data-id="element-67" data-mp="1fgj90ki9z0xy">HT, avant charges</p>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-68" data-mp="3l8yfhx1mtwz5">
            <p className="max-w-xs text-[12px] leading-relaxed text-ink-faint" data-id="element-69" data-mp="3h8fna1vtuowf">Barème indicatif, détaillé et confirmé lors de notre entretien.</p>
            <BracketButton href="#contact" data-id="element-70" data-mp="3nmuz5hlavzcy">En parler avec Jérémy</BracketButton>
          </div>
        </div>
      </div>
    </section>;
}